import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import RequestMarkdownPanelAll from './RequestMarkdownPanelAll';

const RequestMarkdownPanel = ({ configuration, onChange }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: RequestMarkdownPanelAll, narrow: RequestMarkdownPanelAll }}
    onChange={onChange}
  />
);

export default RequestMarkdownPanel;
